import './Partners.css';
import AWFLogo from '../../PageAssets/Photos/Partners/AWFLogo.png';
import PZLALogo from '../../PageAssets/Photos/Partners/PZLALogo.png';
import Lechia from '../../PageAssets/Photos/Partners/Lechia.gif'

const Partners = () => {


    return (
        <div className='PartnersMainDiv'>

            <h2 className='NewsMainButton'>Partnerzy:</h2>

            <div className='PartnersLogosMainDiv'>
              <img src={AWFLogo} alt="Opis zdjęcia" className='PartnerSinglePhoto' />
              <img src={PZLALogo} alt="Opis zdjęcia" className='PartnerSinglePhoto' />
              <img src={Lechia} alt="Opis zdjęcia" className='PartnerSinglePhoto' />
            </div>

        </div>
    )
}

export default Partners;